import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';



export const ParticlesContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const HomeContainer = styled.div`
  position: relative;
  min-height: 100vh;
  padding-bottom: 0;
  margin-bottom: 0;
`;

export const BackgroundGradient = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg,rgb(2, 36, 109) 50%,rgb(2, 47, 114) 100%);
  z-index: -1;
`;

// Añadir este nuevo componente para extender el fondo
export const BackgroundExtender = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg,rgb(2, 36, 109) 50%,rgb(2, 47, 114) 100%);
  z-index: -1;
`;

export const FullscreenSection = styled(motion.section)`
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
  `;

export const CTABanner = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  text-align: center;
  padding: 2rem;
  backdrop-filter: blur(5px);
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.1);
  pointer-events: all;
  box-sizing: border-box;
  z-index: 3;
  
  @media (max-width: 768px) {
    width: 90%;
    margin: 0 auto; /* Esto centra el banner en dispositivos móviles */
    padding: 1.5rem;
    left: 0;
    right: 0;
  }

  span {
    font-size: 1.5rem;
    display: block;
    margin-bottom: 1.5rem;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  }
  
  button {
    background: #007bff;
    color: white;
    border: none;
    padding: 0.8rem 2rem;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 1.1rem;
    
    &:hover {
      background: #0056b3;
      transform: scale(1.05);
      box-shadow: 0 0 20px rgba(0,123,255,0.4);
    }
  }
`;

export const ContentOverlay = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 2;
  padding: 2rem;
  text-align: center;
  

  h1 {
    font-family: 'Open Sans', sans-serif;
    font-size: 5rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
    letter-spacing: 2px;
    transform-origin: center;
    animation: fadeInScale 1s ease-out;
    
    @media (max-width: 768px) {
      font-size: 2px;
      letter-spacing: 1px;
    }
    
    @media (max-width: 480px) {
      font-size: 2rem;
    }
  }

  p {
    font-family: 'DM Sans', sans-serif;
    font-size: 1.8rem;
    max-width: 700px;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
    line-height: 1.6;
    margin-bottom: 2rem;
    opacity: 0.9;
    animation: fadeInUp 1s ease-out 0.3s both;
  }

  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 0.9;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 3rem;
    }
    p {
      font-size: 1.4rem;
    }
  }
`;

export const ScrollIndicator = styled(motion.div)`
position: absolute;
  bottom: 2rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  color: white;
  z-index: 999;
  font-size: 1.4rem;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  gap: 5px;
  
  &:hover {
    border-color: rgba(255, 255, 255, 0.4);
  }

  svg {
    filter: drop-shadow(0 0 5px rgba(255,255,255,0.3));
  }

  &::after {
    content: 'Scroll';
    font-size: 0.9rem;
    letter-spacing: 1px;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    font-size: 1.1rem;
  }
  
  @media (max-width: 480px) {
    width: 80px;
    height: 80px;
    font-size: 0.9rem;
  }
`;

export const IntroSection = styled(motion.section)`
  padding: 6rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  margin-top: -50px;
  position: relative;
  z-index: 2;

  h2 {
    font-family: 'Open Sans', sans-serif;
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    color: #333;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
  }
    
  p {
    font-family: 'DM Sans', sans-serif;
    font-size: 1.2rem;
    color: #666;
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
  }
    @media (max-width: 768px) {
    h2{
    font-size: 1.5rem;
}
  }
`;
  
export const ValueSection = styled(motion.section)`
  padding: 6rem 2rem;
  max-width: 1200px;
  margin: 2rem auto;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  gap: 4rem;
  position: relative;
  z-index: 2;
  isolation: isolate;
 
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 3rem 1.5rem;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    border-radius: 15px;
  }
  
  @media (max-width: 480px) {
    padding: 2rem 1rem;
    width: 85%;
  }
`;

export const ValueImageSection = styled.div`
  flex: 1;
  position: relative; 
  z-index: 3; 

  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
`;

export const ValueContentSection = styled.div`
  flex: 1;
  position: relative; 
  z-index: 3; 
   
  h2 {
    position: relative; 
    font-family: 'Open Sans', sans-serif;
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    color: #333;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
    
    @media (max-width: 768px) {
      font-size: 1.8rem;
    }
    
    @media (max-width: 480px) {
      font-size: 1.5rem;
    }
  }

  p {
    position: relative; 
    font-family: 'DM Sans', sans-serif;
    font-size: 1.2rem;
    color: #666;
    line-height: 1.6;
    margin-bottom: 2rem;
    
    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }
`;

export const ResourcesSection = styled(motion.section)`
  padding: 6rem 2rem;
  max-width: 1200px;
  margin: 2rem auto;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  position: relative;
  z-index: 1;
  margin-bottom: 0;

  h2 {
    font-family: 'Open Sans', sans-serif;
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 2rem;
    color: #333;
  }

  > p {
    font-family: 'DM Sans', sans-serif;
    font-size: 1.2rem;
    text-align: center;
    color: #666;
    max-width: 800px;
    margin: 0 auto 4rem;
    line-height: 1.6;
  }

  @media (max-width: 768px) {
    h2{
    font-size: 1.5rem;
}
  }
`;

export const ResourcesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

export const ResourceCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  .icon-container {
    width: 60px;
    height: 60px;
    background: #007bff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
    color: white;
    font-size: 1.5rem;
  }

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 10px;
    margin: 1rem 0;
  }

  h3 {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: #333;
  }

  p {
    font-family: 'DM Sans', sans-serif;
    font-size: 1rem;
    color: #666;
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  .stat {
    font-style: italic;
    color: #007bff;
    margin: 1rem 0;
    font-size: 0.9rem;
  }
`;

export const ResourceLink = styled(Link)`
  display: inline-block;
  color: #007bff;
  text-decoration: none;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  margin-top: 1rem;
  transition: color 0.3s ease;

  &:hover {
    color: #0056b3;
    text-decoration: underline;
  }
`;

export const heroSlides = [
  {
    image: "https://images.unsplash.com/photo-1537884944318-390069bb8665?auto=format&fit=crop&w=1500",
    title: "Desarrollo Web Innovador",
    subtitle: "Creamos experiencias digitales únicas"
  },
  {
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1500",
    title: "Soluciones Tecnológicas",
    subtitle: "Transformando ideas en realidad"
  },
  {
    image: "https://images.unsplash.com/photo-1504384764586-bb4cdc1707b0?auto=format&fit=crop&w=1500",
    title: "Diseño Web Profesional",
    subtitle: "Potenciando tu presencia digital"
  }
];